<script setup>
/* eslint-disable @intlify/vue-i18n/no-raw-text, vue/no-bare-strings-in-template */
import { computed, reactive, watch } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import {
  DEFAULT_VIP_LEVEL_COLORS,
  normalizeVipLevelColors,
} from 'dashboard/helper/vipLevelHelper';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import SettingsLayout from '../SettingsLayout.vue';

const store = useStore();
const { currentAccount } = useAccount();
const colors = reactive(normalizeVipLevelColors());

const levels = computed(() =>
  Object.keys(DEFAULT_VIP_LEVEL_COLORS).map(level => Number(level))
);

const isUpdating = computed(
  () => store.getters['accounts/getUIFlags']?.isUpdating
);

const applyAccountColors = () => {
  Object.assign(
    colors,
    normalizeVipLevelColors(currentAccount.value?.settings?.vip_level_colors)
  );
};

const resetColors = () => {
  Object.assign(colors, DEFAULT_VIP_LEVEL_COLORS);
};

const saveColors = async () => {
  try {
    await store.dispatch('accounts/update', {
      vip_level_colors: { ...colors },
    });
    useAlert('VIP等级颜色已保存');
  } catch (error) {
    useAlert('保存失败，请稍后重试');
  }
};

watch(
  () => currentAccount.value?.settings?.vip_level_colors,
  applyAccountColors,
  { immediate: true }
);
</script>

<template>
  <SettingsLayout :is-loading="false" :no-records-found="false">
    <template #header>
      <BaseSettingsHeader
        title="VIP等级标签"
        description="读取 App 传入的 vip 或 vip_level 参数，为 VIP 0-20 分别配置在会话列表和联系人资料中显示的标签颜色。此配置对当前账号下所有客服生效。"
      />
    </template>

    <template #body>
      <div class="max-w-4xl">
        <div
          class="grid gap-3 rounded-lg border border-n-weak bg-n-solid-1 p-4 md:grid-cols-2"
        >
          <div
            v-for="level in levels"
            :key="level"
            class="flex items-center justify-between gap-4 rounded-md border border-n-weak bg-n-background px-3 py-2"
          >
            <div class="flex items-center gap-3">
              <span
                class="inline-flex min-w-16 justify-center rounded-full border px-3 py-1 text-sm font-semibold text-n-slate-12"
                :style="{
                  backgroundColor: colors[level],
                  borderColor: colors[level],
                }"
              >
                VIP {{ level }}
              </span>
              <span class="text-sm text-n-slate-11">{{ colors[level] }}</span>
            </div>
            <input
              v-model="colors[level]"
              class="h-9 w-14 cursor-pointer rounded border border-n-weak bg-transparent p-1"
              type="color"
            />
          </div>
        </div>

        <div class="mt-4 flex items-center gap-3">
          <woot-button :is-loading="isUpdating" @click="saveColors">
            保存配置
          </woot-button>
          <woot-button
            variant="clear"
            color-scheme="secondary"
            @click="resetColors"
          >
            恢复默认颜色
          </woot-button>
        </div>
      </div>
    </template>
  </SettingsLayout>
</template>
